<template>
    <div>
        <div v-if="bookingShow" class="order-review">
            <h1>{{paymentMessage}}</h1>
            <p>{{$t('Court')}}: <span>{{court}}</span></p>
            <p>{{$t('Booking time')}}: <span>{{startTime}} - {{endTime}}</span></p>
            <p>{{$t('Date')}}: <span>{{date}}</span></p>
        </div>
        <div v-if="invoiceShow" class="order-review invoice">
          <h1>{{$t('Thank you! Your invoice is paid!')}}</h1>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        data () {
            return {
                errors: [],
                paymentMessage: "",
                bookingShow: false,
                invoiceShow: false,
                bookingId: "",
                startTime: "",
                endTime: "",
                date: "",
                court: ""
            }
        },
        created: function () {
            let urlParams = this.$route.query;
            if (urlParams.booking) {
                axios.get('/getClientBooking' + '?id=' +  urlParams.booking)
                    .then(response => {
                        this.reservation = response.data
                        this.bookingShow = true;
                        this.paymentMessage = this.$t('Your booking has been paid');
                        this.date = this.reservation.date;
                        this.startTime = this.reservation.startTime;
                        this.endTime = this.reservation.endTime;
                        this.court = this.reservation.court;
                    })
                    .catch(e => {
                        this.errors.push(e)
                        if(e.response.status === 401){
                            localStorage.removeItem('token');
                            this.$router.go(0)
                        }
                    })
            } else if (urlParams.invoice) {
                axios.get('/getClientInvoice' + '?id=' +  urlParams.invoice)
                    .then(response => {
                        this.invoiceShow = true;
                    })
                    .catch(e => {
                        this.errors.push(e)
                        if(e.response.status === 401){
                            localStorage.removeItem('token');
                            this.$router.go(0)
                        }
                    })
            }
        }
    }
</script>

<style scoped lang="scss">
    .order-review {
        margin-top: 40px; margin-bottom: 50px;
        h1 {margin-bottom: 20px;}
        span {font-weight: 600;}
        p {line-height: 20px;}
    }
</style>



// WEBPACK FOOTER //
// src/views/payments/PaymentSuccess.vue